import { Schema as S } from "effect";

/**
 * Get KIM Account Request Schema
 *
 * Request to get practice KIM account info for eEB.
 * No parameters needed - returns first available KIM account.
 */
export const GetKimAccountRequestSchema = S.Struct({});

export type GetKimAccountRequest = S.Schema.Type<typeof GetKimAccountRequestSchema>;

